export const FETCH_SIGNED_WEBSOCKET_URL = 'FETCH_SIGNED_WEBSOCKET_URL';
export const SET_SIGNED_WEBSOCKET_URL = 'SET_SIGNED_WEBSOCKET_URL';
export const SET_CSRF_TOKEN = 'SET_CSRF_TOKEN';

/* eslint-disable @typescript-eslint/camelcase, camelcase */
export enum UserPrivileges {
    ar_evaluate = 'ar_evaluate',
    ar_plan = 'ar_plan',
    ar_report = 'ar_report',
    student = 'student',
}
